export default "/kiban/_next/static/images/btn_tools-8fe313dba2b89f095e0bf68bdef822ba.png";